import { Slide } from "@jelly/lesson";

import { task as task04 } from "../../../../../task/course-02/lesson-27/task-04";

const task: Slide = {
  titleHtml:
    "What is the main perceived effect of an acoustic reflection arriving 2 milliseconds<br>after the direct sound?",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task04.id,
        },
      },
    },
  },
};

export default task;
